import { useState, useCallback, useEffect } from 'react';
import { useSdk } from '@packlink/packlink-sdk-provider';
import { transformFormToCustomsInvoice, transformCustomsInvoiceToForm } from '../data/dataTransformation.js';
import Promise$1 from 'bluebird';
import { IShipmentCustomsStatus } from '@packlink/packlink-sdk';
import { useTranslation } from '@packlink/translation-provider';
import { useEvent } from '@packlink/event-handler';

const CONFIRMATION_EVENT = 'CustomsInvoiceCompletedEvent';
const DEFAULT_CONFIRMATION_TIMEOUT = 60 * 1000;
Promise$1.config({
  cancellation: true
});
const useSubmitCustomsInvoice = _ref => {
  let {
    validTariffNumbers,
    clientId,
    timeoutMs = DEFAULT_CONFIRMATION_TIMEOUT
  } = _ref;
  const sdk = useSdk();
  const {
    t
  } = useTranslation();
  const [submitPromise, setSubmitPromise] = useState();
  const {
    eventBind,
    eventUnbind
  } = useEvent(clientId, CONFIRMATION_EVENT);
  const submit = useCallback((formData, externalData) => {
    const customsInvoice = transformFormToCustomsInvoice(formData, externalData);
    const isDraft = formData.status === IShipmentCustomsStatus.DRAFT;
    const submitCustomsInvoice = formData.id && !isDraft ? sdk.v1.customsInvoices.update(customsInvoice) : sdk.v1.customsInvoices.create(customsInvoice);
    let timeoutId;
    const cleanUp = () => {
      clearTimeout(timeoutId);
      eventUnbind();
    };

    // Customs invoice creation is confirmed via Pusher
    const confirmSubmission = new Promise$1((resolve, reject) => {
      timeoutId = setTimeout(() => reject(new Error(t('customs-form.error.submit-timeout'))), timeoutMs);
      eventBind(resolve);
    }).finally(cleanUp);
    const submission = Promise$1.all([submitCustomsInvoice, confirmSubmission]).then(_ref2 => {
      let [response] = _ref2;
      const form = transformCustomsInvoiceToForm({
        currency: formData.currency,
        t,
        status: IShipmentCustomsStatus.COMPLETED,
        validTariffNumbers
      })(response);
      form.authorised = formData.authorised;
      form.customsTerms = formData.customsTerms;
      return form;
    });
    setSubmitPromise(submission);
    return submission;
  }, [eventBind, eventUnbind, sdk.v1.customsInvoices, t, timeoutMs, validTariffNumbers]);
  useEffect(() => () => submitPromise === null || submitPromise === void 0 ? void 0 : submitPromise.cancel(), [submitPromise]);
  return submit;
};

export { CONFIRMATION_EVENT, useSubmitCustomsInvoice };
//# sourceMappingURL=useSubmitCustomsInvoice.js.map
